import axiosGraphQL from './GraphQL/axiosGraphQL';
import { HandoverQueries } from './GraphQL/Queries/HandoverQueries';
import { HandoverVariables } from './GraphQL/Variables/HandoverVariables';

export const HandoverApis = {
  getListHandover: async (params: any): Promise<any> => {
    return await axiosGraphQL.post('/graphql', {
      query: HandoverQueries.GET_LIST_HANDOVER,
      variables: HandoverVariables.getListHandover(params),
    });
  },
  confirmHandover: async (params: any): Promise<any> => {
    return await axiosGraphQL.post('/graphql', {
      query: HandoverQueries.CONFIRM_HANDOVER,
      variables: HandoverVariables.confirmHandover(params),
    });
  },
};
